import TempWorkerDocumentApiTempWorker from '@/api/TempWorkerDocumentApiTempWorker';
import TempWorkerDocumentApiAgency from '@/api/TempWorkerDocumentApiAgency';
import { getReadableIdentityPieceType, identityPieceType } from '@/utils/tempWorkerDocument';
import useSelfService from '../SelfService';
import { useNotif } from '@orion.ui/orion';

type IdentityType = {
	label?: string,
	value: number,
}

class TempWorkerDocumentService {

	private get api () {
		return useSelfService().self.isTempWorker() ? TempWorkerDocumentApiTempWorker : TempWorkerDocumentApiAgency;
	}

	public identityPieceTypeOptions = [
		{
			label: getReadableIdentityPieceType(identityPieceType.IdentityCard),
			value: identityPieceType.IdentityCard,
		},
		{
			label: getReadableIdentityPieceType(identityPieceType.ResidentPermit),
			value: identityPieceType.ResidentPermit,
		},
		{
			label: getReadableIdentityPieceType(identityPieceType.Passport),
			value: identityPieceType.Passport,
		},
	] as IdentityType[];

	public driverLicenceOptions = [
		'B',
		'AM',
		'A1',
		'A2',
		'A',
		'C',
		'C1',
		'C1E',
		'D',
		'D1',
		'D1E',
		'BE',
		'CE',
		'DE',
	];

	get tommorow () {
		const today = new Date();
		const tommorow = today.setDate(today.getDate() + 1);
		return new Date(tommorow);
	};

	async deleteDocumentAsync (id: number) {
		try {
			if (this.api === TempWorkerDocumentApiTempWorker) {
				await this.api.delete(id);
			}
		} catch (e: any) {
			useNotif.danger(`Oops, une erreur est survenue`);
		}
	}

	async uploadDocumentAsync (documentModelToAdd: IAddTempWorkerDocumentModel) {
		try {
			if (this.api === TempWorkerDocumentApiTempWorker) {
				const res = await this.api.add(documentModelToAdd);
				useNotif.success(`Transfert terminé`, `Votre document a bien été enregistré`);
				return res;
			}
		} catch (e: any) {
			useNotif.danger(`Oops, une erreur est survenue`);
		}
	}

	async updateDocumentAsync (documentModelToAdd: IAddTempWorkerDocumentModel) {
		try {
			if (this.api === TempWorkerDocumentApiTempWorker) {
				const res = await this.api.add(documentModelToAdd);
				useNotif.success(`Transfert terminé`, `Votre document a bien été enregistré`);
				return res;
			}
		} catch (e: any) {
			useNotif.danger(`Oops, une erreur est survenue`);
		}
	}

	async updateFileAsync (updateFileTempWorkerDocumentModel: Omit<IUpdateFileTempWorkerDocumentModel, 'userId' | 'binaryFiles'>) {
		try {
			if (this.api === TempWorkerDocumentApiTempWorker) {
				await TempWorkerDocumentApiTempWorker.updateFile(updateFileTempWorkerDocumentModel);
			}
		} catch (e: any) {
			useNotif.danger(`Oops`, e?.response?.data);
		}
	}

	async updateExpirationDateAsync (tempWorkerDocumentId: number, expirationDate: Date) {
		try {
			if (this.api === TempWorkerDocumentApiTempWorker) {
				await TempWorkerDocumentApiTempWorker.updateExpirationDate(tempWorkerDocumentId, { expirationDate: expirationDate.toPost() });
			}
		} catch (e: any) {
			useNotif.danger(`Oops`, e?.response?.data);
		}
	}

	async updateMetaDataAsync (id: number, metaData: Record<string, any>) {
		try {
			if (this.api === TempWorkerDocumentApiTempWorker) {
				await TempWorkerDocumentApiTempWorker.updateMetaData(id, metaData);
			}
		} catch (e: any) {
			useNotif.danger(`Oops`, e?.response?.data);
		}
	}

	async listAsync (...args: Parameters<typeof TempWorkerDocumentApiTempWorker.list>) {
		const { data } = await TempWorkerDocumentApiTempWorker.list(...args);
		return data;
	}

	download (id: Parameters<typeof this.api.download>[0]) {
		this.api.download(id);
	}

	view (id: Parameters<typeof this.api.view>[0]) {
		this.api.view(id);
	}
}

const tempWorkerDocumentServiceSingleton = new TempWorkerDocumentService();

export default function useTempWorkerDocumentService () {
	return tempWorkerDocumentServiceSingleton;
}
